exports.linkResolver = (doc) => {
  switch (doc.type) {
    default: {
      return `/${doc.uid}/`;
    }
  }
};
